<template>
  <div id="dayTabList">
    <div style="display: none;">
      <MPMultiDaysSummary v-show="finalEvents.length > 0"/>
    </div>
    <p class="loading-indicator" v-show="showLoadingIndicator">
      <pulse-loader :color="'#9d9d9d'"></pulse-loader>
    </p>
    <b-card no-body v-if="localEventList.length > 0">
      <b-tabs pills card v-model="tabIndex">
        <b-tab
          
          v-for="item in localEventList"
          :key="item.day"
          :active="item.day == '1' ? true : false"
        >
          <template slot="title">
            {{strings.day}} #{{item.day}}
          </template>
          <transition name="fade">
            <div v-if="!item.isChosen">
              <!-- Time pickers -->
              <div class="event__timePicker__wrapper">
                <!-- Event date -->
                <!--<label class="form__label event_date_label input-width--15">
                  {{ strings.date }}
                  <span class="form__input">{{ calculateEventDate(item) }}</span>
                </label>-->
                <button type="button" class="btn float-right btn-danger btn-sm remove-day" v-if="localEventList.length > 1" @click="remove(item.day)"><font-awesome-icon icon="trash" /> {{ strings.remove }}</button>
                <label class="form__label event_date_label input-width--15">
                  {{ strings.date }}
                  <div class="daypicker">
                    <input 
                      class="flatpickr form__input js-datepicker flatpickr-input" 
                      :id="'daypick_' + item.day" 
                      :placeholder="strings.whenyourmeetingis"
                      :data-id="item.day"
                      @change="changeEventDate($event)"
                      :value="item.date"
                      >
                  </div>
                </label>
                <!-- Event start time -->
                <label class="form__label input-width--15" v-if="currentTab == 'room'">
                  {{ strings.starttime }}
                  <select
                    class="vueTimePicker form__input"
                    :data-id="item.day"
                    @change="changeEventStartTime($event)"
                    :value="item.start_time"
                  >
                    <option 
                      v-for="time in timeOptions" 
                      :key="time.id" 
                      :value="time.value"
                      :disabled="isAfterEndTime(time.value, item.end_time)"
                      >{{ time.text }}</option>
                  </select>
                </label>

                <!-- Event end time -->
                <label class="form__label input-width--15" v-if="currentTab == 'room'">
                  {{ strings.endTime }}
                  <select
                    class="vueTimePicker form__input"
                    :data-id="item.day"
                    @change="changeEventEndTime($event)"
                    :value="item.end_time"
                  >
                    <option 
                      v-for="time in timeOptions" 
                      :key="time.id" 
                      :value="time.value"
                      :disabled="isBeforeStartTime(item.start_time, time.value)"
                      >{{ time.text }}</option>
                  </select>
                </label>
                
                <label class="form__label input-width--10">
                  {{ strings.attendees }}
                  <input
                    :data-id="item.day"
                    @change="changeEventDelegates($event)"
                    :value="item.delegates"
                    type="number"
                    class="form__input vueTimePicker"
                    :placeholder="strings.howmany"
                  >
                </label>

              </div>

               <div class="error_block">
                <p class="form__note" v-if="item.outOfBizHours && item.bizHours['start_time']" style="text-align: center; font-size:14px;">{{ strings.bizHours }}: {{ item.bizHours['start_time'] }} - {{ item.bizHours['end_time'] }}</p>
                <p class="form__note" v-if="item.outOfBizHours && item.bizHours['venue_closed']" style="text-align: center; font-size:14px;">{{ strings.venueClosed }}</p>
              </div>
              <MPPackageList
                v-if="currentTab == 'package' && !item.outOfBizHours"
                :packages="item.packages"
                :day="item.day"
                :selected_package="item.selected_package"
                :delegates="item.delegates"
              />
              <!-- Room choice -->
              <MPRoomList
                v-if="currentTab == 'room' && !item.outOfBizHours"
                :rooms="item.finalList"
                :day="item.day"
                :selected_room="item.selected_room"
                :mt_length="item.mt_length"
              />

              <!-- Room choice in Package-->
              <!--<MPRoomListinPackage
                v-if="currentTab == 'package' && !item.outOfBizHours"
                :packages="item.packages"
                :room_list_in_package="item.room_list_in_package"
                :selected_room_in_package="item.selected_room_in_package"
                :day="item.day"
              />-->
            </div>
          </transition>
          <transition name="fade">
            <div v-if="item.isChosen">
              <ul class="event-summary-list">
                <li class="event-summary-item" v-for="value in item.chosenItemText" :key="value">
                  {{ value }}
                </li>
              </ul>
              <b-btn size="sm" variant="danger" class="float-right" @click="discard(item.day)"><font-awesome-icon icon="minus-circle" /> {{ strings.discard }}</b-btn>
            </div>
          </transition>


        </b-tab>
        <!-- New Tab Button (Using tabs slot) -->
        <template v-slot:tabs-end>
          <b-nav-item @click.prevent="newTab" href="#"><font-awesome-icon icon="plus-circle" size="lg" /></b-nav-item>
        </template>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import MPDayTabItem from "./DayTabItem";
import MPPackageList from "./PackageList";
import MPRoomList from "./RoomList";
import MPRoomListinPackage from "./RoomListinPackage";
import MPMultiDaysSummary from "./MultiDaysSummary";
import VueTimepicker from "vue2-timepicker";
import moment from "moment";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

import fpickr from "flatpickr"
//import locale for flatpickr.
import { Russian } from "flatpickr/dist/l10n/ru.js";
import { Finnish } from "flatpickr/dist/l10n/fi.js"
import { Danish } from "flatpickr/dist/l10n/da.js"
import { French } from "flatpickr/dist/l10n/fr.js"
import { German } from "flatpickr/dist/l10n/de.js"
import { Italian } from "flatpickr/dist/l10n/it.js"
import { Latvian } from "flatpickr/dist/l10n/lv.js"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import { Swedish } from "flatpickr/dist/l10n/sv.js"
import { Mandarin } from "flatpickr/dist/l10n/zh.js"
import { Czech } from "flatpickr/dist/l10n/cs.js"
import { english } from "flatpickr/dist/l10n/default.js"
let defaultTabListEventStartTime = window.isNCH == '1' ? '08:00': '09:00';


export default {
  data() {
    return {
      defaultEventStartTime: {
        HH: defaultTabListEventStartTime,
        mm: "00:00"
      },
      defaultEventEndTime: {
        HH: "17:00",
        mm: "00:00"
      },
      chosenItemText: {},
      localEventList: [],
      tabCounter: 1,
      firstDayPickerRendered: false,
      defaultDate : moment().format('DD-MM-YYYY'),
      timeOptions : [
          {id: 0, text: '00:00' , value: '00:00'},
          {id: 1, text: '00:30' , value: '00:30'},
          {id: 2, text: '01:00' , value: '01:00'},
          {id: 3, text: '01:30' , value: '01:30'},
          {id: 4, text: '02:00' , value: '02:00'},
          {id: 5, text: '02:30' , value: '02:30'},
          {id: 6, text: '03:00' , value: '03:00'},
          {id: 7, text: '03:30' , value: '03:30'},
          {id: 8, text: '04:00' , value: '04:00'},
          {id: 9, text: '04:30' , value: '04:30'},
          {id: 10, text: '05:00' , value: '05:00'},
          {id: 11, text: '05:30' , value: '05:30'},
          {id: 12, text: '06:00' , value: '06:00'},
          {id: 13, text: '06:30' , value: '06:30'},
          {id: 14, text: '07:00' , value: '07:00'},
          {id: 15, text: '07:30' , value: '07:30'},
          {id: 16, text: '08:00' , value: '08:00'},
          {id: 17, text: '08:30' , value: '08:30'},
          {id: 18, text: '09:00' , value: '09:00'},
          {id: 19, text: '09:30' , value: '09:30'},
          {id: 20, text: '10:00' , value: '10:00'},
          {id: 21, text: '10:30' , value: '10:30'},
          {id: 22, text: '11:00' , value: '11:00'},
          {id: 23, text: '11:30' , value: '11:30'},
          {id: 24, text: '12:00' , value: '12:00'},
          {id: 25, text: '12:30' , value: '12:30'},
          {id: 26, text: '13:00' , value: '13:00'},
          {id: 27, text: '13:30' , value: '13:30'},
          {id: 28, text: '14:00' , value: '14:00'},
          {id: 29, text: '14:30' , value: '14:30'},
          {id: 30, text: '15:00' , value: '15:00'},
          {id: 31, text: '15:30' , value: '15:30'},
          {id: 32, text: '16:00' , value: '16:00'},
          {id: 33, text: '16:30' , value: '16:30'},
          {id: 34, text: '17:00' , value: '17:00'},
          {id: 35, text: '17:30' , value: '17:30'},
          {id: 36, text: '18:00' , value: '18:00'},
          {id: 37, text: '18:30' , value: '18:30'},
          {id: 38, text: '19:00' , value: '19:00'},
          {id: 39, text: '19:30' , value: '19:30'},
          {id: 40, text: '20:00' , value: '20:00'},
          {id: 41, text: '20:30' , value: '20:30'},
          {id: 42, text: '21:00' , value: '21:00'},
          {id: 43, text: '21:30' , value: '21:30'},
          {id: 44, text: '22:00' , value: '22:00'},
          {id: 45, text: '22:30' , value: '22:30'},
          {id: 46, text: '23:00' , value: '23:00'},
          {id: 47, text: '23:30' , value: '23:30'},
      ],
    };
  },
  components: {
    MPDayTabItem,
    MPPackageList,
    MPRoomList,
    MPRoomListinPackage,
    VueTimepicker,
    MPMultiDaysSummary,
    PulseLoader,
  },
  computed: {
    showLoadingIndicator() {
      if(this.currentTab == 'package'){
        return this.$store.state.packagesReady == false;
      } else {
        return this.$store.state.roomsReady == false;
      }
    },
    finalEvents(){
      return this.$store.state.finalEvents;
    },
    tabIndex() {
      return this.$store.state.tabIndex;
    },
    eventList() {
      return this.$store.state.eventList;
    },
    currentTab() {
      return this.$store.state.currentTab;
    },
    isOpera() {
      return this.$store.state.isOpera;
    },
    strings() {
      return this.$store.state.strings;
    },
    startDate() {
      return this.$store.state.date;
    }
  },
  watch: {
    eventList(value){
      this.localEventList = value;


      if(this.localEventList.length > 0){
        setTimeout(() => {
          this.localEventList.forEach(element => {
            let newID = "#daypick_" + element.day;
            fpickr(newID, {
              altInput: true,
              dateFormat: 'd-m-Y',
              defaultDate: element.date,
              minDate: this.defaultDate,
            });
          });
        }, 100);
      }

    }
  },
  methods: {
    isAfterEndTime(startTime, endTime){
      startTime = moment(startTime, 'HH:mm');
      endTime = moment(endTime, 'HH:mm');
      return startTime.isAfter(endTime);
    },
    isBeforeStartTime(startTime, endTime){
      startTime = moment(startTime, 'HH:mm');
      endTime = moment(endTime, 'HH:mm');
      return endTime.isBefore(startTime);
    },
    newTab() {
      this.$store.dispatch("createNewDayTab");
    },
    discard(day){
      this.$store.commit('popToFinalEvents', day);
      setTimeout(() => {          
      let dayID = "#daypick_" + day;
        fpickr(dayID, {
          altInput: true,
          dateFormat: 'd-m-Y',
          minDate: this.defaultDate,
        });
      }, 100);
    },
    remove(day){
      this.$store.commit('popToEvents', day);
    },
    calculateEventDate(item) {
      let startDate = this.$store.state.date;
      let startTime = item.start_time;
      let startDateTime = moment(
        startDate + " " + startTime,
        "DD-MM-YYYY HH:mm"
      );
      let currentEventDate = startDateTime
        .add(item.day - 1, "days")
        .format("LL");
      return currentEventDate;
    },
    changeEventDate(event) {
      this.getStuffForEachDay(event, 'date');
    },
    changeEventStartTime(event) {
      this.getStuffForEachDay(event, 'start_time');
    },
    changeEventEndTime(event) {
      this.getStuffForEachDay(event, 'end_time');
    },
    changeEventDelegates(event) {
      this.getStuffForEachDay(event, 'delegates');
    },
    getStuffForEachDay(event, changed_item){
      let _day = parseInt(event.target.attributes["data-id"].value);
      let _value = event.target.value;
      let eventDate = '';
      let eventStartTime = '';
      let eventEndTime = '';
      let eventDelegates = '';
      let isOpera = this.isOpera;

      this.eventList.forEach(element => {
        if (parseInt(element.day) == _day) {
          switch (changed_item) {
            case 'date':
              element.date = _value;
              eventDate = _value;
              eventStartTime = element.start_time;
              eventEndTime = element.end_time;
              eventDelegates = element.delegates;
              break;
            case 'start_time':
              eventDate = element.date;
              element.start_time = _value;
              eventStartTime = _value;
              eventEndTime = element.end_time;
              eventDelegates = element.delegates;
              break;
            case 'end_time':
              eventDate = element.date;
              eventStartTime = element.start_time;
              element.end_time = _value;
              eventEndTime = _value;
              eventDelegates = element.delegates;
              break;
            case 'delegates':
              eventDate = element.date;
              eventStartTime = element.start_time;
              eventEndTime = element.end_time;
              element.delegates = _value;
              eventDelegates = _value;
              break;
            default:
              break;
          }
        }
      });

      this.$store.commit("setEventList", this.eventList);
      let payload = {
        date: eventDate,
        startTime: eventStartTime,
        endTime: eventEndTime,
        day: _day,
        delegates: eventDelegates
      };

      this.$store.dispatch("checkBizHours", payload);

      if (this.currentTab == "room") {
        if(isOpera){
          this.$store.dispatch("getOperaRoomForEachDay", payload);
        } else {
          this.$store.dispatch("getRoomForEachDay", payload);
        }
      } else {
        if(isOpera){
          this.$store.dispatch("getOperaPackageForEachDay", payload);
        } else {
          // Not yet developed
        }
      }
    }
  }
};
</script>

<style>
#dayTabList {
  margin-bottom: 20px;
}

#dayTabList ul {
  margin-top: 0;
  margin-bottom: 1rem;
  outline: none;
}

#dayTabList a {
  text-decoration: none;
  outline: none;
}

#dayTabList a:hover {
  text-decoration: underline;
}

#dayTabList .fade {
  transition: opacity 0.15s linear;
}

@media screen and (prefers-reduced-motion: reduce) {
  #dayTabList .fade {
    transition: none;
  }
}

#dayTabList .fade:not(.show) {
  opacity: 0;
}

#dayTabList .nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

#dayTabList .nav-link {
  display: block;
  padding: 0.5rem 1rem;
}

#dayTabList .nav-link:hover,
.nav-link:focus {
  text-decoration: none;
}

#dayTabList .nav-pills .nav-link {
  border-radius: 0.25rem;
}

#dayTabList .nav-pills .nav-link.active {
  color: #fff;
  background-color: #0050FF;
}

#dayTabList .tab-content > .tab-pane {
  display: none;
}

#dayTabList .tab-content > .active {
  display: block;
}

#dayTabList .card {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

#dayTabList .card-body {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1.25rem;
}

#dayTabList .card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  color: inherit;
  background-color: #f3f8fd;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

#dayTabList .card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}
</style>


<style scoped>
.form__note{
  text-align: left !important;
  clear: both;
}
.daypicker{
  margin-top: 14px !important;
}

.form__label {
  margin-right: 2%;
  float: left;
}
.input-width--20 {
  width: 20%;
}
.input-width--15 {
  width: 15%;
}
.input-width--10 {
  width: 10%;
}

@media only screen and (max-width: 1024px)  {
  .input-width--10, .input-width--15, .input-width--20 {
    width: 100%;
  }
}

.event__timePicker__wrapper {
  min-height: 100px;
  height: 100%;
}
.event_date_label .form__input {
  border: none !important;
  padding: 0 !important;
  font-weight: 500 !important;
  margin-top: 14px !important;
}
.float-right{
  float: right;
}
.btn-sm {
    padding: .25rem .5rem;
    font-size: .875rem;
    line-height: 1.5;
    border-radius: .2rem;
}
.btn-danger {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
    cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s
}



</style>

<style>
  .event-summary-list {
    list-style-type : none;
  }

  .event-summary-item {
    margin-bottom: 5px;
  }
  .btn {
    outline: none;
  }
  .remove-day{
    margin-top: 30px;
  }
</style>

